// extracted by mini-css-extract-plugin
export const topImage = "BlogList-module--topImage--1K2Na";
export const topTitle = "BlogList-module--topTitle--160CB bootstrap--h4--18WKK bootstrap--font-weight-bold--1VvNN";
export const latestImage = "BlogList-module--latestImage--2cBtQ";
export const latestTitle = "BlogList-module--latestTitle--3Oz8e bootstrap--mb-2--w642D bootstrap--h6--29Wuv bootstrap--font-weight-bold--1VvNN";
export const postImage = "BlogList-module--postImage--1j8fC";
export const postTitle = "BlogList-module--postTitle--2CR-t bootstrap--mb-1--3W7w4 bootstrap--h4--18WKK bootstrap--font-weight-bold--1VvNN";